import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BzMasterAgGrid } from "../../components";
import { useLocation, useNavigate } from "react-router";
import WatchlistSymbolColumn from "../Watchlist/WatchlistSymbolColumn";
import { WatchlistGridPopover } from "../Watchlist";
import { convertScripResponseWatchlistGrid, getExchangeName, getMktSegIdFromMappedMktSegId, convertToDate, displayZeroStateForGrid, isGuestUser, openOverviewModal, openOrderEntryModal, updateDontmissToArrRowData } from "../../utils/global_functions";
import { toastConfig } from "../../redux/actions/toast";
import { LOCATIONS, ORDER_ENTRY_BUTTON_TOGGLE, SCRENNERS_KEYS } from "../../utils/global_variables";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import GridHeaderSearch from "../GridHeaderSearch";
import { handleModal } from "../../redux/actions/modals";
import ZeroStates from "../ZeroStates";
import { LoginLoader } from "../Login";



const ScreenersGrid = ({ segment, trayExpanded, isExpanded, ...props }) => {
    const screenersGridData = useSelector(state => state.screeners.arrScreenersGridData);
    const objselectedScreener = useSelector(state => state.screeners.objselectedScreener);
    const selectedTab = useSelector(state => state.screeners.selectedTab);
    const strSeletedCategory = useSelector(state => state.screeners.strSeletedCategory);
    const groupedDontMissData = useSelector(state => state?.dontMiss?.groupedDontMissData);
    const isLoading = useSelector(state => state.edis.isLoading);
    const [showZeroStates, setShowZeroStates] = useState(false);
    let strSearch = null;


    const [arrScreenersGridData, setArrScreenersGridData] = useState([])

    useEffect(() => {
        if (screenersGridData?.length) {
            if (objselectedScreener?.GroupId === 17 || objselectedScreener?.GroupId === 25) {
                const filterScreenersData = screenersGridData?.filter((each) => each?.nOpenInterestChange > 0)
                setArrScreenersGridData(filterScreenersData)
            } else if (objselectedScreener?.GroupId === 27 || objselectedScreener?.GroupId === 26) {
                const filterScreenersData = screenersGridData?.filter((each) => each?.nPercChange < 0)
                setArrScreenersGridData(filterScreenersData)
            } else if (objselectedScreener?.GroupId === 18 || objselectedScreener?.GroupId === 19) {
                const filterScreenersData = screenersGridData?.filter((each) => each?.nPercChange > 0)
                setArrScreenersGridData(filterScreenersData)
            }
            else {
                setArrScreenersGridData(screenersGridData)
            }
        } else {
            setArrScreenersGridData([])
        }
    }, [screenersGridData, objselectedScreener, selectedTab, strSeletedCategory])
    const filterOptions = [
        'equals',
        'notEqual',
        'lessThan',
        'lessThanOrEqual',
        'greaterThan',
        'greaterThanOrEqual',
        'inRange',
        'blank',
        'notBlank'
    ];
    //Vaibhav Singh:15-04-24:BT-107427: Added Loader and field validation: Start
    const fieldToNotShowSign = [
        "nVolume",
        "LTP",
        "nOpenInterest",
        "nLTP",
        "CurrPrice",
        "latbv",
        "nResistance",
        "nSupport",
        "nClose",
        "Premium",
        "Discount",
        "nHigh",
        "nLow",
        "nClosePrice"
    ];
    const location = useLocation();
    const dispatch = useDispatch(); {/* Vaibhav Singh [20-12-2023] : Sidetray screeners */ }
    const navigate = useNavigate();
    const screenersRef = useRef();
    const onChangeGridHeaderSearch = useCallback((e) => {
        strSearch = e?.target?.value;
        screenersRef?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(screenersRef);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, [isExpanded,]);

    useEffect(() => {
        onChangeGridHeaderSearch()
    }, [trayExpanded])

    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, []);

    const sortingComparator = useCallback((number1, number2) => {
        number1 = parseFloat(number1);
        number2 = parseFloat(number2);
        if (number1 === null) {
            return 0.00;
        }
        if (number2 === null) {
            return 0.00;
        }
        return number1 - number2;
    }, []);
    const getFilterDataForGrid = ({ filterOption, value, filterText }) => {
        if (filterText == null) {
            return false;
        } else {
            switch (filterOption) {
                case 'equals': {
                    return parseFloat(filterText) === parseFloat(value);
                }
                case 'notEqual': {
                    return parseFloat(filterText) !== parseFloat(value);
                }
                case 'lessThan': {
                    return parseFloat(value) < parseFloat(filterText);
                }
                case 'lessThanOrEqual': {
                    return parseFloat(value) <= parseFloat(filterText);
                }
                case 'greaterThan': {
                    return parseFloat(value) > parseFloat(filterText);
                }
                case 'greaterThanOrEqual': {
                    return parseFloat(value) >= parseFloat(filterText);
                }
                case 'inRange': {
                    const agFilterModel = screenersRef?.current?.api?.getFilterModel();
                    if (Object?.keys(agFilterModel)?.length > 0) {
                        const fromValue = agFilterModel[Object?.keys(agFilterModel)[0]].filter;
                        const toValue = agFilterModel[Object?.keys(agFilterModel)[0]].filterTo;
                        return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                    } else {
                        return false;
                    }
                }
                case 'blank': {
                    return false;
                }
                case 'notBlank': {
                    return true;
                }
                default:
                    return false;
            }
        }
    };

    const doesExternalFilterPass = useCallback(
        (node) => {
            if (!strSearch) {
                return true;
            } else {
                //Vaibhav Singh: BT-116978 : Fixed filter for row data in search
                //Azeem k :optamize search functionality 26-10-2023
                const keywords = strSearch?.toString()?.toLowerCase()?.split(' ');
                let strRowData = (node?.data?.sSymbol || node?.data?.Symbol || "") + (node?.data?.sExchange || "") + (node?.data?.nExpiryDate1 || "") + (node?.data?.nStrikePrice || node?.data?.nStrikePrice1 || "") + (node?.data?.sOptionType || "");
                let bIsMatch = keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
                setTimeout(() => {
                    const arrFiltered = screenersRef?.current?.api?.getModel()?.rowsToDisplay?.filter((row) => {
                        return row['displayed'] === true;
                    });
                    if (arrFiltered?.length > 0) {
                        dispatch(toastConfig({}));
                        strSearch = null;
                    } else {
                        //  dispatch(toastConfig({ autoDismiss: true, show: true, timer: 5000, message: "No matches found try adjust your search or filter to find what you are looking for" }));//ManasaB:10-09-2024 : Hotfix issue
                        strSearch = null;
                    }
                }, 10);
                return bIsMatch;
            }
        },
        [strSearch]
    );




    const numFormmater = (value, field) => {
        let valueFomatted = 0;
        if (fieldToNotShowSign?.includes(field)) {
            valueFomatted = value !== undefined ? value ? !`${value}`.includes('-') ? `${parseFloat(value)?.toFixed(2)}` : parseFloat(value)?.toFixed(2) : "0.00" : "0.00";
        } else if (field === "FAOPercChange") {
            valueFomatted = value !== undefined ? parseFloat(value)?.toFixed(2) ? !`${parseFloat(value)?.toFixed(2)}`.includes('-') ? `+${parseFloat(value)?.toFixed(2)}` : parseFloat(value)?.toFixed(2) : "0.00" : "0.00";
        } else if (field === "Circuit") {
            valueFomatted = value;
        }
        else {
            valueFomatted = value !== undefined && value !== 0 ? value ? !`${value}`.includes('-') ? `+${parseFloat(value)?.toFixed(2)}` : parseFloat(value)?.toFixed(2) : "0.00" : "0.00";
        }
        if (location?.pathname === LOCATIONS.DASHBOARD) {
            return valueFomatted;
        } else {

            return <span style={{ fontSize: "0.75em" }}>{valueFomatted}</span>;
        }
    };
    //Vaibhav Singh: 06-03-24: Added PopOver in aggried of scanner: Start
    const handleRender = ({ data: arrRowData, value, colDef, params, ...props }, placement) => {
        let convertedData = [];
        if (arrRowData) {
            arrRowData['MktSegId'] = arrRowData?.ScripData_NSE || arrRowData?.ScripData_BSE ? getMktSegIdFromMappedMktSegId(arrRowData?.ScripData_NSE?.MarketSegmentId || arrRowData?.ScripData_BSE?.MarketSegmentId) : getMktSegIdFromMappedMktSegId(arrRowData?.nMarketSegmentId);
            arrRowData['sSymbol'] = arrRowData?.sSymbol ? arrRowData?.sSymbol : arrRowData?.Symbol;
            arrRowData['nToken'] = arrRowData?.ScripData_NSE || arrRowData?.ScripData_BSE ? arrRowData?.ScripData_NSE?.ODINCode || arrRowData?.ScripData_BSE?.ODINCode : arrRowData?.nToken;
            arrRowData['sSeries'] = arrRowData?.ScripData_NSE || arrRowData?.ScripData_BSE ? arrRowData?.ScripData_NSE?.Series || arrRowData?.ScripData_BSE?.Series : arrRowData?.sSeries;
            arrRowData['sExchange'] = getExchangeName(parseFloat(arrRowData['MktSegId']));
            arrRowData['nLTP'] = arrRowData?.nLTP && !isNaN(arrRowData?.nLTP) ? parseFloat(arrRowData?.nLTP)?.toFixed(2) : parseFloat(arrRowData?.LTP || arrRowData?.CurrPrice)?.toFixed(2);
            arrRowData['nPercChange'] = arrRowData?.nPercChange ? parseFloat(arrRowData?.nPercChange)?.toFixed(2) : parseFloat(arrRowData?.FAOPercChange || 0)?.toFixed(2);
            arrRowData['nPriceTick'] = 0.00;
            arrRowData['DecimalLocator'] = 2;
            if (segment !== "Equity") {
                arrRowData['nExpiryDate1'] = arrRowData?.nExpiryDate ? convertToDate(arrRowData?.nExpiryDate, "DDMMMYYYY").toUpperCase() : arrRowData?.nExpiryDate1 ? convertToDate(arrRowData?.nExpiryDate1, "DDMMMYYYY").toUpperCase() : undefined;
                arrRowData['nStrikePrice1'] = arrRowData?.nStrikePrice !== -0.01 && arrRowData?.nStrikePrice !== 0.00 && arrRowData?.nStrikePrice !== 0.0000 ? arrRowData?.nStrikePrice : '';
                arrRowData['sOptionType'] = arrRowData?.sOptionType || '';
            }

            if (colDef?.field === "Circuit") {
                value = `${arrRowData['nLowPriceRange'] ? arrRowData['nLowPriceRange'] : '0.00'}-${arrRowData['nHighPriceRange'] ? arrRowData['nHighPriceRange'] : '0.00'}`;
            }
            if (colDef?.field === "price") {
                value = `${arrRowData['nLTP'] - arrRowData['nClose']}`;
            }

            convertedData = updateDontmissToArrRowData(groupedDontMissData, convertScripResponseWatchlistGrid([arrRowData], true));

        } else {
            convertedData = [];
        }
        return (
            (convertedData?.length) ?
                <WatchlistGridPopover isAddtoWatchlist={true} placement={placement} arrRowData={convertedData[0]} pageCalled={true} {...props} >
                    {colDef?.field === "sSymbol" || colDef?.field === "Symbol" ? <WatchlistSymbolColumn isScrenners={true} arrRowData={convertedData[0]} value={value} pageCalled={true} {...props} />
                        : colDef?.field === "nResistance" ? <div> R{arrRowData?.level} : <span className="color-positive">{value} </span></div> : colDef?.field === "nSupport" ? <div> S{arrRowData?.level} : <span className="color-negative">{value} </span></div> : numFormmater(value, colDef?.field)}
                </WatchlistGridPopover> : null
        );
    };

    //trayExpanded
    // const ToolTipRenderer = (props) => {
    //     return (
    //         <BzToolTip placement='bottom' TooltipMsg={`${props.displayName}`}>
    //             <div className={`color-subtext`} style={{ marginLeft: `${trayExpanded ? 110 : 10}px` }}>
    //                 {props?.displayName}
    //             </div>
    //         </BzToolTip>
    //     );

    // };

    const arrColumnDefs = useMemo(() => {
        let defaultDef = [
            {
                field: (objselectedScreener?.GroupId === 48) ? 'Symbol' : 'sSymbol',
                headerName: 'SYMBOL', headerComponent: GridHeaderSearch,
                cellRenderer: (props) => handleRender(props, location?.pathname === LOCATIONS.DASHBOARD ? 'right' : 'left'),
                initialWidth: location?.pathname === LOCATIONS.DASHBOARD ? 350 : 200,
                minWidth: location?.pathname === LOCATIONS.DASHBOARD ? 350 : 200,
                resizable: true,
                headerComponentParams: { onChangeGridHeaderSearch, gridRef: screenersRef },
                pinned: 'left',
                suppressMovable: true,
                lockPosition: "left",
                suppressNavigable: true,
                flex: 1
            },
            {
                field: objselectedScreener?.GroupId === 48 ? 'CurrPrice' : 'nLTP',
                // headerComponent: ToolTipRenderer,
                headerName: 'LTP',
                initialWidth: location?.pathname === LOCATIONS.DASHBOARD ? 250 : 75,
                minWidth: location?.pathname === LOCATIONS.DASHBOARD ? 240 : 75,
                filter: 'agTextColumnFilter',
                filterParams: {
                    textMatcher: getFilterDataForGrid,
                    filterOptions: filterOptions
                },
                cellRenderer: (props) => handleRender(props, 'left'),
                comparator: sortingComparator,
                resizable: true,
                flex: 1
            },
            {
                field: 'nPercChange',
                headerName: (objselectedScreener?.GroupId === 22 || objselectedScreener?.GroupId === 30) ? "TODAYS PRICE CHNG %" : "%CHANGE",
                cellRenderer: (props) => handleRender(props, 'left'),
                // headerComponent: ToolTipRenderer,
                cellClassRules: 
                    {
                        'color-positive': params => !params?.data?.nPercChange?.includes('-'),
                        'color-negative': params => params?.data?.nPercChange?.includes('-'),
                    },
                initialWidth: location?.pathname === LOCATIONS.DASHBOARD ? 250 : 98,
                minWidth: location?.pathname === LOCATIONS.DASHBOARD ? 240 : 98,
                filter: 'agTextColumnFilter',
                filterParams: {
                    textMatcher: getFilterDataForGrid,
                    filterOptions: filterOptions
                },
                comparator: sortingComparator,
                resizable: true,
                flex: 1
            }
        ];
        SCRENNERS_KEYS[objselectedScreener?.GroupName?.replaceAll(" ", "")]?.forEach((each, i) => {
            defaultDef?.push({
                field: each?.field,
                // headerComponent: ToolTipRenderer,
                headerName: each?.headerName?.toUpperCase(),
                cellRenderer: (props) => handleRender(props, 'left'),
                cellRendererParams: {
                    signShow: each?.signShow
                },
                initialWidth: location?.pathname === LOCATIONS.DASHBOARD ? 240 : 110,
                minWidth: location?.pathname === LOCATIONS.DASHBOARD ? 240 : 110,
                filter: 'agTextColumnFilter',
                filterParams: {
                    textMatcher: getFilterDataForGrid,
                    filterOptions: filterOptions
                },
                cellClassRules: (each?.showColor) ? (each?.sign) ?
                    {
                        'color-positive': params => !`${params?.data?.['nLTP'] - params?.data?.['nClose']}`?.includes('-'),
                        'color-negative': params => `${params?.data?.['nLTP'] - params?.data?.['nClose']}`?.includes('-')
                    }
                    : {
                        'color-positive': params => params?.data?.[each?.field] !== 0 && params?.data?.[each?.field] !== undefined ? !`${params?.data?.[each?.field]}`?.includes('-') : '',
                        'color-negative': params => params?.data?.[each?.field] !== 0 && params?.data?.[each?.field] !== undefined ? `${params?.data?.[each?.field]}`?.includes('-') : '',
                    } : {},
                comparator: sortingComparator,
                valueFormatter: params => {
                    if (params?.value === "" || params?.value === undefined) {
                        return "0.00";
                    }
                },
                resizable: true,
                flex: 1
            });
        });
        return defaultDef;
    }, [GridHeaderSearch, filterOptions, handleRender, objselectedScreener?.GroupName, sortingComparator]);

    // Azeem K - 29-08-2024 :Added f1,f2,f5 and enter shortcut to Grid  -- Start 
    const isOpen = useSelector(state => state?.addendumreducer?.isOpen);
    const modals = useSelector(state => state.modals.modals);

    const bISWatchlistShrtCutsAllow = useMemo(() => {

        return !Object.keys(modals)?.some((eachModal) => modals[eachModal]) && !isOpen; //isOpen is state of addendum modal

    }, [modals, isOpen]);
    // Azeem K - 29-08-2024 :Added f1,f2,f5 and enter shortcut to Grid  -- End 

    const handleOverview = (e) => {
        e.preventDefault(); // Prevent the default browser behavior for F5 key press
        if (!isGuestUser()) {
            if (screenersRef?.current?.api.getSelectedRows().length > 0 && bISWatchlistShrtCutsAllow) {
                const [arrSelectedRowScripData] = convertScripResponseWatchlistGrid([screenersRef?.current?.api?.getSelectedRows()[0]]);
                const bIsShowingGridCheckboxes = screenersRef?.current?.columnApi?.getColumn(
                    screenersRef?.current?.columnApi?.columnModel?.columnDefs[0]?.colId
                )?.visible;

                if (!Boolean(bIsShowingGridCheckboxes) && arrSelectedRowScripData?.length > 0) {
                    openOverviewModal(true, arrSelectedRowScripData, false, false, dispatch, {});
                }
            }
            else { }
        }
        else {
            dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
        }
    };

    // Azeem K - 29-08-2024 :Added f1,f2,f5 and enter shortcut to Grid  -- Start 
    const objLoginSession = useSelector(state => state.auth?.objLoginSession);

    const handleBuySell = (buySell) => {
        if (!isGuestUser()) {
            if (screenersRef?.current?.api.getSelectedRows().length > 0 && bISWatchlistShrtCutsAllow) {
                const objRowData = screenersRef?.current?.api?.getSelectedRows()[0];
                if (objRowData) {
                    openOrderEntryModal(null, null, objLoginSession, objRowData?.MktSegId, objRowData?.nToken, buySell);
                } else { }
            } else { }
        }
        else {
            dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
        }


    };


    // useSingleKey('f1', (e) => {

    //     e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
    // });
    // useSingleKey('f2', (e) => {

    //     e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.SELL);
    // });

    // useSingleKey('f5', handleOverview);

    // useSingleKey('enter', (e) => {
    //     if (bISWatchlistShrtCutsAllow) {
    //         handleOverview(e);
    //     }
    // }
    // );
    // Azeem K - 29-08-2024 :Added f1,f2,f5 and enter shortcut to Grid  -- End 

    //Vaibhav Singh: 06-03-24: Added PopOver in aggried of scanner: End


    //Deepti B: BT 110050: Added class to change font of row values according setting preference

    const handleKeyEvents = useCallback((e) => {
        let key = e?.key?.toLowerCase()
        switch (key) {
            case 'f1':

                e.preventDefault(); // Prevent the default browser behavior for F1 key press
                handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
                break;
            case 'f2':

                e.preventDefault(); // Prevent the default browser behavior for F1 key press
                handleBuySell(ORDER_ENTRY_BUTTON_TOGGLE.SELL);
                break;
            case 'f5':
                handleOverview(e);

                break;
            case 'enter':
                if (bISWatchlistShrtCutsAllow) {
                    handleOverview(e);
                }
                break;
            default: break;
        }
    }, [bISWatchlistShrtCutsAllow]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyEvents)
        return () => {
            document.removeEventListener('keydown', handleKeyEvents)
        }
    }, [handleKeyEvents]);

    const arrGridRowData = useMemo(() => {

        let abc = objselectedScreener?.GroupId === 40 ? arrScreenersGridData?.advance : objselectedScreener?.GroupId === 41 ? arrScreenersGridData?.decline : (objselectedScreener?.GroupId === 24 || objselectedScreener?.GroupId === 16) ? arrScreenersGridData?.filter(item => item.nPrevVolumeChange > 0) : arrScreenersGridData;
        return abc;
    }, [arrScreenersGridData, objselectedScreener?.GroupId, screenersGridData]);

    useEffect(() => {
        setTimeout(() => {
            let firstRowNode = screenersRef?.current?.api?.getDisplayedRowAtIndex(0);
            if (firstRowNode) {
                firstRowNode.setSelected(true);
            }
        }, 1500);

    }, [arrGridRowData]);
    useEffect(() => {
        if (arrScreenersGridData?.length === 0) {
            setTimeout(() => {
                setShowZeroStates(true);
            }, 3000);
        } else {
            setShowZeroStates(false);
        }
    }, [arrScreenersGridData, screenersGridData]);
    return (
        <>
            {isLoading ? <div className={(location?.pathname === LOCATIONS.DASHBOARD) ? `screeners-ag-grid-wrapper` : `screeners-ag-grid-sidebar-wrapper`}><LoginLoader spinner={isLoading} /></div>
                : arrScreenersGridData && arrScreenersGridData?.length != 0 ?
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col>
                                <BzMasterAgGrid
                                    isCompress={true}
                                    ref={screenersRef}
                                    arrRowData={arrGridRowData}
                                    arrColumnData={arrColumnDefs}
                                    className={(location?.pathname === LOCATIONS.DASHBOARD) ? `ag-theme-alpine d-flex-1 screeners-ag-grid-wrapper` : trayExpanded ? `ag-theme-alpine d-flex-1 screeners-ag-grid-sidebar-wrapper` : `ag-theme-alpine d-flex-1 screeners-ag-grid-expand-sidebar-wrapper`}
                                    overlayNoRowsTemplate={'No data to show'}
                                    isExternalFilterPresent={isExternalFilterPresent}
                                    doesExternalFilterPass={doesExternalFilterPass}
                                    rowClass='font-enlarge' defaultColProps={location?.pathname === LOCATIONS.DASHBOARD ? { flex: 1 } : trayExpanded ? { flex: 1 } : {}} />
                            </Col>
                        </Row>
                    </Container>
                    : (!showZeroStates) ?
                        <div className='zero-state-alerts zero-state-alerts-xxl'>
                            <Row className='g-0'>
                                <Col className='text-center'>
                                    <div className='spinner-overlay'>
                                        <Row className='g-0'>
                                            <Col>
                                                <div className='text-center mb-3'>
                                                    <Spinner className='spinner-border color-text' animation="border" />
                                                </div>
                                                <div className='font-regular font-size2 color-nodata'>We are actively scanning the markets.</div>
                                                <div className='font-regular font-size2 color-nodata'>You can wait or try <span className='color-primary cursor-pointer'>refreshing the page.</span></div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        :
                        <div className='zero-state-alerts zero-state-alerts-xxl'>
                            <ZeroStates subText="" isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                            <div className='font-regular font-size2 color-nodata'>There is currently no data available for your selection.</div>
                        </div>
            }

        </>
    );
    //Vaibhav Singh:15-04-24:BT-107427: Added Loader and field validation: End
};
export default memo(ScreenersGrid);